import React from 'react';

import MoneyOffIcon from '@material-ui/icons/MoneyOff';
import SyncAltIcon from '@material-ui/icons/SyncAlt';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import API from '../../services/api';
import TableCheck from '../tablecheck';

import DialogTransferencia from './dialogtransferencia';

// import DepositoDialog from './dialogdeposito';
// import SaqueDialog from './dialogsaque';
// import TransferenciaDialog from './dialogtransferencia';
// import useStyles from './styles';

export default function ComponentOperationsCheck(props) {
  const [openTransferencia, setOpenTransferencia] = React.useState(false);
  const [itemTransferencia, setItemTransferencia] = React.useState(null);

  function componentDidMount() {
    setOpenTransferencia(itemTransferencia !== null);
  }

  React.useEffect(componentDidMount, [itemTransferencia]);
  //const userKeys = (key) => {
  //  switch (key) {
  //    case 'account':
  //      return ['id'];
  //    case 'classe':
  //      return ['classe', 0, 'name'];
  //    case 'name':
  //      return ['name'];
  //    case 'school':
  //      return ['classe', 0, 'serie', 'school', 'name'];
  //    case 'serie':
  //      return ['classe', 0, 'serie', 'name'];
  //    default:
  //      return [];
  //  }
  //};

  const keys = (key) => {
    switch (key) {
      case 'account':
        return ['id'];
      case 'classe':
        return ['user', 'classe', 0, 'name'];
      case 'name':
        return ['user', 'name'];
      case 'saldo':
        return ['saldo'];
      case 'school':
        return ['user', 'classe', 0, 'serie', 'school', 'name'];
      case 'serie':
        return ['user', 'classe', 0, 'serie', 'name'];
      case 'description':
        return ['description'];
      case 'owners_name':
        return ['owners_name'];
      case 'to_account':
        return ['to_account', 'name'];
      case 'valor':
        return ['valor'];
      default:
        return [];
    }
  };

  const handleOnClickTransferencia = (item) => (event) => {
    setItemTransferencia(item);
  };

  const handleOnConfirmTransferencia = () => {
    setItemTransferencia(null);
  };

  const handleOnCancelTransferencia = () => {
    setItemTransferencia(null);
  };

  const columns = [
    {
      id: 'account',
      keys: keys('account'),
      label: 'Conta',
      align: 'left', // center|inherit|justify|left|right
      padding: 'none', // ["checkbox","default","none"]
      money: false,
      disablePadding: false,
      sortable: false,
      icon: undefined,
      onClick: undefined,
    },
    {
      id: 'name',
      keys: keys('name'),
      label: 'Cliente',
      align: 'left',
      padding: 'none',
      money: false,
      disablePadding: false,
      sortable: false,
      icon: undefined,
      onClick: undefined,
    },
    {
      id: 'school',
      keys: keys('school'),
      label: 'Agência',
      align: 'left',
      padding: 'none',
      money: false,
      disablePadding: false,
      sortable: false,
      icon: null,
      onClick: undefined,
    },
    {
      id: 'serie',
      keys: keys('serie'),
      label: 'Série',
      align: 'left',
      padding: 'default',
      money: false,
      disablePadding: false,
      sortable: false,
      icon: null,
      onClick: undefined,
    },
    {
      id: 'saldo',
      keys: keys('saldo'),
      label: 'Saldo',
      align: 'left',
      padding: 'default',
      money: true,
      disablePadding: false,
      sortable: false,
      icon: null,
      onClick: undefined,
    },
    {
      id: 'classe',
      keys: keys('classe'),
      label: 'Turma',
      align: 'center',
      padding: 'default',
      money: false,
      disablePadding: false,
      sortable: false,
      icon: null,
      onClick: undefined,
    },
    // {
    //   id: 'sacar',
    //   keys: null,
    //   label: 'Sacar',
    //   align: 'center',
    //   padding: 'none',
    //   money: false,
    //   disablePadding: false,
    //   sortable: true,
    //   icon: <MoneyOffIcon />,
    //   onClick: handleOnClickSaque,
    // },
    {
      id: 'transferir',
      label: 'Transferir',
      align: 'center',
      padding: 'default',
      money: false,
      disablePadding: false,
      sortable: true,
      keys: null,
      icon: <SyncAltIcon />,
      onClick: handleOnClickTransferencia,
    },
  ];

  const columns2 = [
    {
      id: 'description',
      keys: keys('description'),
      label: 'Motivo',
      align: 'left', // center|inherit|justify|left|right
      padding: 'none', // ["checkbox","default","none"]
      money: false,
      disablePadding: false,
      sortable: false,
      icon: undefined,
      onClick: undefined,
    },
    {
      id: 'owners_name',
      keys: keys('owners_name'),
      label: 'Responsável',
      align: 'left',
      padding: 'none',
      money: false,
      disablePadding: false,
      sortable: false,
      icon: undefined,
      onClick: undefined,
    },
    {
      id: 'to_account',
      keys: keys('to_account'),
      label: 'Beneficiário',
      align: 'left',
      padding: 'none',
      money: false,
      disablePadding: false,
      sortable: false,
      icon: null,
      onClick: undefined,
    },
    {
      id: 'valor',
      keys: keys('valor'),
      label: 'Valor',
      align: 'left',
      padding: 'default',
      money: true,
      disablePadding: false,
      sortable: false,
      icon: null,
      onClick: undefined,
    },
  ];

  return (
    <>
      <DialogTransferencia
        item={itemTransferencia}
        onCancel={handleOnCancelTransferencia}
        onConfirm={handleOnConfirmTransferencia}
        open={openTransferencia}
      ></DialogTransferencia>
      <TableCheck
        columns={columns}
        fetch={API.Accounts}
        icon={<MoneyOffIcon />}
        keys={keys}
        title={'Operações'}
        toolbarbuttons={1}
      ></TableCheck>
  {false &&
      <TableCheck
        columns={columns2}
        fetch={API.Depositos}
        icon={<VerifiedUserIcon />}
        keys={keys}
        title={'Validações'}
        toolbarbuttons={2}
      ></TableCheck>
  }
    </>
  );
}
